import { GoFileSymlinkFile } from "react-icons/go";
import "../../../css/IconStyle.css";

const RequestIcon = () => {
  return <GoFileSymlinkFile size={22} className="sidebar-icon" />;
};

export default RequestIcon;
